var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlphabet = function SvgAlphabet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82274 1.17165C9.11411 -0.390554 6.88589 -0.390549 6.17726 1.17166L0.0886314 14.5944C-0.138682 15.0955 0.0850792 15.6852 0.588415 15.9115C1.09175 16.1378 1.68406 15.9151 1.91137 15.4139L3.88164 11.0704H12.1184L14.0886 15.4139C14.3159 15.9151 14.9083 16.1378 15.4116 15.9115C15.9149 15.6852 16.1387 15.0955 15.9114 14.5944L9.82274 1.17165ZM11.2112 9.07037L8 1.99121L4.78885 9.07037H11.2112Z"
  })));
};
export default SvgAlphabet;